import { evaluateMessage } from "./evaluateMessage";
import { playMessage } from "./playMessage";
import { deleteMessage } from "./deleteMessage";
import { deletePinnedMessage } from "./deletePinnedMessage";
import { pinMessage } from "./pinMessage";
import { convertMessageToImage } from "./convertMessageToImage";
import { messageActions } from "../components/messageActions";
import { shareMessage } from "./shareMessage";
import { regenerateMessage } from "./regenerateMessage";
import { regenerateWithFeedbackMessage } from "./regenerateWithFeedbackMessage";
import { branchMessage } from "./branchMessage";

export function initMessageActions(message) {
    messageActions(message.find('.g-chatform-message-actions-selector'));
    evaluateMessage(message.find('.g-chatform-message-feedback .g-chatform-message-actions-options-single'));
    playMessage(message.find('.g-chatform-message-play'));
    if (message.closest('.g-chatform-pinned').length > 0) {
        deletePinnedMessage(message.find('.g-chatform-message-delete'));
    } else {
        deleteMessage(message.find('.g-chatform-message-delete'));
    }
    shareMessage(message.find('.g-chatform-message-share'));
    pinMessage(message.find('.g-chatform-message-pin'));
    convertMessageToImage(message.find('.g-chatform-message-create-image .icon-wrapper'));
    regenerateMessage(message.find('.g-chatform-message-regenerate'));
    regenerateWithFeedbackMessage(message.find('.g-chatform-message-feedback-regenerate'));
    branchMessage();
}
